import Head from "next/head";
import { END } from "redux-saga";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import Officedetail from "../../src/components/pages/office/Officedetail";
import { wrapper } from "../../src/config/Store";
import { getAllCMS } from "../../src/redux/cms/CMSActions";
import { useRouter } from "next/router";
import { resourceTypes } from "../../src/utils/CommonFunctions";
import Notfound from "../404";
import constants from "../../src/utils/Constants";
import Routes from "../../src/routes/Routes";

const { CMS_TYPES } = constants;

const nextOfficeListing = () => {
  const {
    query: { deskName },
  } = useRouter();

  const pageMeta = useSelector(({ cms }) => {
    const { cmsMap, boards } = cms;
    let cms_page;
    Object.values(resourceTypes).forEach(({ _id, active, cmsPage }) => {
      if (_id === deskName && active) {
        cms_page = cmsPage;
      }
    });
    const boardKey = JSON.stringify({
      type: CMS_TYPES.PAGE_META,
      page_name: cms_page,
    });
    const mPageDetailsId = boards?.[boardKey]?.list?.[0];
    return cmsMap[mPageDetailsId];
  });

  

  const resourceType = useMemo(() => {
    let mResourceType;
    Object.values(resourceTypes).forEach((resourceType) => {
      if (resourceType._id === deskName && resourceType.active) {
        mResourceType = resourceType;
      }
    });

    if (mResourceType) {
      return mResourceType;
    } else if (deskName === "other") {
      return {
        _id: "other",
        name: "Coming Soon",
        desc: "Access to Flexible desks in shared spaces",
        pageTitle: "New Property Add Coming Soon - Go Bermondsey",
        pageDescription: "Coming Soon",
        pageCanonical: `https://go-bermondsey.co.uk/office-spaces/other`,
      };
    }
  }, [deskName]);

  if (!resourceType) {
    return <Notfound />;
  }


  //console.log(resourceType, "resourceType")
  return (
    <>
      <Head>
        <title>{pageMeta?.name}</title>
        <meta name="description" content={`${pageMeta?.description}`} />
        <meta itemProp="name" content="description" />
        <meta itemProp="description" content="description" />
        <meta itemProp="image" content="image" />
        <link
          rel="canonical"
          href={`${Routes?.domain}${Routes?.office}/${deskName}`}
        />

        

        {resourceType?.bodyWebPageSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: resourceType?.bodyWebPageSchema,
          }}
        />
        )}

        

        
      </Head>
      <Officedetail />

      
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const { deskName } = context.params;
    let cmsKey = deskName;
    let cms_type;
    let cms_page;
    Object.values(resourceTypes).forEach(
      ({ _id, cms_id, active, cmsType, cmsPage }) => {
        if (_id === deskName && active) {
          cmsKey = cms_id;
          cms_type = cmsType;
          cms_page = cmsPage;
        }
      }
    );

    const cmsState = store.getState().cms;

    const params = { type: "ImageGallery", resource_type: cmsKey };
    const homeSliderBoard = cmsState.boards[JSON.stringify(params)];

    if (!homeSliderBoard) {
      store.dispatch(getAllCMS(params));
    }

    const knowMoreParams = { type: "KnowMore", resource_type: cmsKey };
    const knowMoreBoard = cmsState.boards[JSON.stringify(knowMoreParams)];
    if (!knowMoreBoard) {
      store.dispatch(getAllCMS(knowMoreParams));
    }

    const resoucePageMetaParams = {
      type: CMS_TYPES.PAGE_META,
      page_name: cms_page,
    };

    const resoucePageMetaBoard =
      cmsState.boards[JSON.stringify(resoucePageMetaParams)];
    if (!resoucePageMetaBoard) {
      store.dispatch(getAllCMS(resoucePageMetaParams));
    }

    const resoucePageParams = { type: cms_type };
    const resoucePageBoard = cmsState.boards[JSON.stringify(resoucePageParams)];

    if (!resoucePageBoard) {
      store.dispatch(getAllCMS(resoucePageParams));
    }

    if (
      !homeSliderBoard ||
      !knowMoreBoard ||
      !resoucePageMetaBoard ||
      !resoucePageBoard
    ) {
      store.dispatch(END);
    }

    await store.sagaTask.toPromise();
  }
);

export default nextOfficeListing;
